import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MotorQuote } from '../../shared/models/quote';
import { environment } from '../../../environments/environment';
import { CreateInvoluntaryRetrenchmentQuote } from '../../shared/models/create-involuntary-retrenchment-quote';

@Injectable({
    providedIn: 'root',
})
export class QuoteService {
    private apiUrl = `${environment.apiUrl}/api/motor/quote`;
    private southernOracleApiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}

    getMotorQuote(id: number): Observable<MotorQuote> {
        return this.http.get<any>(`${this.apiUrl}/api/${id}`);
    }

    postMotorQuote(formData: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, formData);
    }

    fetchAllCustomerQuotes(customerId: number): Observable<any> {
        return this.http.get<any>(
            `${this.apiUrl}/api/find?customerId=${customerId}`
        );
    }

    fetchQuotesToPrint(quoteIds: number[]): Observable<any> {
        return this.http.get<any>(
            `${this.apiUrl}/api/fetch?quoteIds=${quoteIds}`
        );
    }
    createInvoluntaryRetrenchmentQuote(
        payload: CreateInvoluntaryRetrenchmentQuote
    ): Observable<any> {
        return this.http.post<any>(
            `${this.southernOracleApiUrl}/api/involuntary-retrenchment`,
            payload
        );
    }
}
